import { useState } from "react";

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem("token");
    if (tokenString === "undefined") {
      return undefined;
    }
    const userToken = JSON.parse(tokenString);
    if (userToken !== null) {
      //token expired --> Clear localStorage and return null
      if (
        new Date() >=
        new Date(JSON.parse(localStorage.getItem("token"))[".expires"])
      ) {
        localStorage.clear();
        return undefined;
      }
    }
    return userToken?.access_token;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    if (userToken) {
      localStorage.setItem("token", JSON.stringify(userToken));
      setToken(userToken["access_token"]);
    }
  };

  return {
    setToken: saveToken,
    token,
  };
}
